export default __webpack_public_path__ + "static/media/proxima-nova-bold.91edebc9.woff2";